// Runtime polyfills for older browsers (e.g. Safari 12): loads core-js stable +
// regenerator so missing modern JS APIs (Promise.allSettled, Object.fromEntries,
// Array.flat, String.matchAll, globalThis, etc.) don't throw and blank the page.
// MUST be imported before React/app code.
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
